/**
 * Handle Modal
 */
const handleModal = () => {
  const $modalTrigger = $(".js-modal");
  $modalTrigger.on("click", function (event) {
    const $this = $(this);
    const $targetModal = $($this.attr("href"));
    $targetModal.addClass("is-open");

    $("body").toggleClass("no-scroll");

    event.preventDefault();

    // Handle the carousel not being visible to set size by default.
    if ($(".js-modal #product")) {
      $("#product .product__slider").slick("setPosition");
      $("#product .product__thumbs").slick("setPosition");
    }
  });
};

handleModal();
